export default {
  // place hidden DOMs, like hidden <video>
  DOM_DISPLAY_HIDDEN: -1,
  // place DOMs, like <video>
  DOM_DISPLAY: 1,
  // place canvas
  VIEW: 2,
  // place DOMs for interaction purpose
  DOM_INTERACTION: 3,
}
